// extracted by mini-css-extract-plugin
var _1 = "DefaultElement_container__3e7ba";
var _2 = "DefaultElement_destContainer__a44ef";
var _3 = "DefaultElement_emptyAnswer__225a6";
var _4 = "DefaultElement_row__57d28";
export { _1 as "container", _2 as "destContainer", _3 as "emptyAnswer", _4 as "row" }
